export const sections = [
  { title: '"Новости"', value: 'news' },
  { title: '"Аналитика"', value: 'analytics' },
];
